import { Routes } from '@angular/router';
import { authorizationGuard } from './core/guards/authorization/authorization.guard';
import { noAuthorizationGuard } from './core/guards/authorization/no-authorization.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./modules/dashboard/dashboard.module').then(
        (m) => m.DashboardModule
      ),
    canActivate: [authorizationGuard]
  },
  {
    path: 'ui-toolkit',
    loadChildren: () =>
      import('./shared-modules/ui-toolkit/ui-toolkit.module').then(
        (m) => m.UiToolkitModule
      )
  },
  {
    path: 'authorization',
    loadChildren: () =>
      import('./modules/authorization/authorization.module').then(
        (m) => m.AuthorizationModule
      ),
    canActivate: [noAuthorizationGuard]
  }
];
